import { render, staticRenderFns } from "./DriverAbsent.vue?vue&type=template&id=1ed684ee&"
import script from "./DriverAbsent.vue?vue&type=script&lang=js&"
export * from "./DriverAbsent.vue?vue&type=script&lang=js&"
import style0 from "./DriverAbsent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports